var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('main',[_vm._m(0),_c('section',{staticClass:"safety-info"},[_c('div',{staticClass:"image-scroll"},_vm._l((5),function(n){return _c('img',{key:n,attrs:{"src":`/assets/png${n}.png`,"alt":`Safety Image ${n}`}})}),0)])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"shop"},[_c('i',{staticClass:"fas fa-shield-alt"}),_c('h1',[_vm._v("Safety")])])
}]

export { render, staticRenderFns }